






















import Vue from 'vue'
import { camelizeKeys } from '@/utils'

import ItemFactory from '../../elements/likert/ItemFactory'
import SurveyMixin from '../SurveyMixin'

const settings = camelizeKeys(require('./sewip-therapists.yml'))
const factory = new ItemFactory(settings)

export default Vue.extend({
  mixins: [SurveyMixin],
  computed: {
    computedLocale(): string {
      return this.locale || this.$i18n.locale
    },
  },
  data() {
    return {
      settings,
      items: factory.scanRange(1, 21),
    }
  },
  props: {
    locale: {
      type: String,
    },
  },
})
